import React, { FunctionComponent } from 'react';
import ReactLoading from 'react-loading';

import {
  ButtonContainer,
  AContainer,
  getFontColorByType,
  Theme,
  Icon,
  Text,
} from './styles';

interface Props {
  type?: 'button' | 'submit' | 'reset';
  theme?: Theme;
  onClick?: () => void;
  loading?: boolean;
  disable?: boolean;
  icon?: string;
  href?: string;
  download?: string;
  marginTop?: number;
  'data-cy'?: string;
}

const Button: FunctionComponent<Props> = ({
  children,
  theme,
  onClick,
  loading,
  disable,
  type,
  icon,
  href,
  download,
  marginTop,
  'data-cy': dataCy,
}) => {
  let Container: any;
  if (href || download) {
    Container = AContainer;
  } else {
    Container = ButtonContainer;
  }

  return (
    <Container
      type={type || 'button'}
      theme={theme || 'NORMAL'}
      disabled={loading || disable}
      onClick={onClick}
      href={href}
      download={download}
      marginTop={marginTop || 0}
      data-cy={dataCy}
    >
      {loading ? (
        <ReactLoading
          type="spin"
          height={30}
          width={30}
          color={getFontColorByType(theme || 'NORMAL')}
        />
      ) : (
        <>
          {icon ? (
            <>
              <Icon src={icon} />
              <Text>{children}</Text>
            </>
          ) : (
            children
          )}
        </>
      )}
    </Container>
  );
};

export default Button;
